module.exports = __webpack_public_path__ + "img/home_business_bg.33b7e624.png";